import { useContext, useEffect, useState } from 'react';
import { FluidDropdown } from '../../../../components/ui/fluid-dropdown';
import { convertToArenaOptions, convertToCourtOptions } from '../../../../utils/index';
import { SearchContext } from '../..';
import { Search as SearchIcon, MapPin, RotateCcw } from 'lucide-react';

interface VideoSearchProps {
  dataArena: any;
  onSearch: () => void;
  onClear?: () => void;
}

function VideoSearch({ dataArena, onSearch, onClear }: VideoSearchProps) {
  const { court, arena, setArena, setCourt, date, setDate } = useContext(SearchContext);
  const [arenaOptions, setArenaOptions] = useState();
  const [courtOptions, setCourtOptions] = useState();

  useEffect(() => {
    if (dataArena) setArenaOptions(convertToArenaOptions(dataArena));
  }, [dataArena]);

  useEffect(() => {
    if (arena) setCourtOptions(convertToCourtOptions(arena));
  }, [arena]);

  const isDisabled = !(arena && court && date);

  return (
    <div className="pt-40 pb-8" style={{ backgroundColor: '#0a0a0a' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-white mb-2">Seus Vídeos</h2>
          {arena && (
            <div className="inline-flex items-center gap-1.5 bg-zinc-800/60 border border-zinc-800 rounded-full px-3 py-1">
              <MapPin className="h-3 w-3 text-orange-400" />
              <span className="text-zinc-300 text-xs">{arena.value}</span>
              {court && <span className="text-zinc-500 text-xs">· {court.value}</span>}
            </div>
          )}
        </div>

        {/* Filters row */}
        <div className="grid grid-cols-3 gap-3 mb-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-medium text-zinc-500">Arena</label>
            <FluidDropdown
              selectedOption={arena}
              options={arenaOptions}
              placeholder="Arena"
              onSelect={setArena}
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-medium text-zinc-500">Quadra</label>
            <FluidDropdown
              selectedOption={court}
              options={courtOptions}
              placeholder="Quadra"
              onSelect={setCourt}
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-medium text-zinc-500">Data</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="w-full h-10 px-3 rounded-lg text-sm font-medium border border-zinc-700 bg-zinc-900 text-zinc-300 focus:outline-none focus:ring-2 focus:ring-orange-500/50"
              style={{ colorScheme: 'dark' }}
            />
          </div>
        </div>
        {/* Action buttons */}
        <div className="grid grid-cols-2 sm:flex sm:w-auto gap-2 mt-1">
          <button
            onClick={onSearch}
            disabled={isDisabled}
            className="h-10 px-6 rounded-lg font-semibold text-white border-none cursor-pointer text-sm flex items-center justify-center gap-2 transition-all duration-300 hover:scale-[1.02] disabled:opacity-40 disabled:cursor-not-allowed"
            style={{ background: isDisabled ? '#3f3f46' : 'linear-gradient(135deg, #e57605, #f29b2a)' }}
          >
            <SearchIcon className="w-4 h-4" />
            Buscar
          </button>
          {onClear && (
            <button
              onClick={onClear}
              className="h-10 px-4 rounded-lg font-medium text-zinc-400 border border-zinc-700 bg-transparent cursor-pointer text-sm flex items-center justify-center gap-2 transition-all duration-200 hover:text-white hover:border-zinc-500"
            >
              <RotateCcw className="w-3.5 h-3.5" />
              Limpar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default VideoSearch;
